import { render, staticRenderFns } from "./LinkedMarketingProduct.vue?vue&type=template&id=02431448&"
import script from "./LinkedMarketingProduct.vue?vue&type=script&lang=js&"
export * from "./LinkedMarketingProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports